import React from 'react';

export function ToshokanIntro() {
  return (
    <div className="toshokan-intro">
      <h1 className="toshokan-title">
        Zenzeii is a reading room for Japanese literature.
      </h1>
      <p className="toshokan-description">
        The Toshokan Pass is your membership to read without limits
        and to make Japanese a part of your everyday life.
      </p>
      <div className="toshokan-rule" />
    </div>
  );
}

export default ToshokanIntro;
